export default __webpack_public_path__ + "static/media/upload.ace02d4d.svg";